<template>
		<v-row>
			<v-col cols="12" md="4">
				<v-card class="pa-2" tile>
					<h4 class="text-center">Общая статистика</h4>
					<commitChart></commitChart>
				</v-card>

			</v-col>
				<v-col cols="12" md="8">

			
					<v-card class="pa-2" tile>
						<h4 class="text-center">Мировая статистика</h4>
						<statOnCountries></statOnCountries>
					</v-card>


				</v-col>
			
		</v-row>
</template>

<script>
	import CommitChart from './newChart'
	import statOnCountries from './chartOnCountries'

	export default {
		components: {
			CommitChart, statOnCountries
		}
	}


</script>

<style>
	
</style>